export default __webpack_public_path__ + "static/media/hamburger-icon-white.71451c0e.svg";